import { __awaiter } from "tslib";
import BASE_CONSTANTS from '@/constants/baseConstants';
import services from '@/services/index';
import _ from 'lodash';
export const setIndexes = (vm) => {
    vm.base.forEach((folder, folderIndex) => {
        folder.index = folderIndex;
        folder.items.forEach((item, itemIndex) => {
            item.folderIndex = folderIndex;
            item.index = itemIndex;
            item.folderID = folder.id;
            item.isLastItem = itemIndex + 1 === folder.items.length;
            item.inDefaultFolder = folder.defaultFolder;
            item.locked = BASE_CONSTANTS.DEFAULT_LOCKED_COINS.some((coinName) => coinName === item.name) ? true : item.locked;
            item.isDefaultLocked = BASE_CONSTANTS.DEFAULT_LOCKED_COINS.some((coinName) => coinName === item.name);
            item.isAvailableToPay = false;
        });
    });
};
let allMarketPairs = [];
let pairsIsPreloading = false;
function loadMarketPairs() {
    return new Promise((resolve) => {
        services.binance.getSpotExchangeInfo(null).then((response) => {
            if (response.success) {
                const allSymbols = response.data.symbols;
                _.remove(allSymbols, (item) => BASE_CONSTANTS.FIAT_LIST.includes(item.quoteAsset));
                pairsIsPreloading = false;
                resolve(allSymbols);
            }
            pairsIsPreloading = false;
        });
    });
}
export function getMarketPairs() {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve) => {
            if (allMarketPairs.length) {
                resolve(allMarketPairs);
            }
            else {
                pairsIsPreloading = true;
                loadMarketPairs().then((loadedResult) => {
                    allMarketPairs = loadedResult;
                    resolve(allMarketPairs);
                });
            }
        });
    });
}
export const adductionToStep = (val, step) => {
    const v = parseFloat(val + '');
    const s = step + '';
    if (parseFloat(s) >= 1) {
        return Math.trunc(v);
    }
    else {
        let stepLength;
        if (!s.includes('e')) {
            stepLength = s.split('.')[1].length;
        }
        else {
            stepLength = Math.abs(+s.split('e')[1]);
        }
        return Math.trunc((v * Math.pow(10, stepLength))) / Math.pow(10, stepLength);
    }
};
export const findMinimumWithdrawalAmount = (networks) => {
    const networksArray = Object.values(networks);
    return networksArray.reduce((result, { minimumAmount }) => {
        return result > parseFloat(minimumAmount) ? parseFloat(minimumAmount) : result;
    }, parseFloat(networksArray[0].minimumAmount));
};
